var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerformanceWidgetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#2A9D8F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 20.5,
    stroke: "#9097A5",
    strokeOpacity: 0.3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3766_23436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.2083 12.875C28.7167 12.875 29.2042 13.0769 29.5636 13.4364C29.9231 13.7958 30.125 14.2833 30.125 14.7917V28.2083C30.125 28.7167 29.9231 29.2042 29.5636 29.5636C29.2042 29.9231 28.7167 30.125 28.2083 30.125H14.7917C14.2833 30.125 13.7958 29.9231 13.4364 29.5636C13.0769 29.2042 12.875 28.7167 12.875 28.2083V14.7917C12.875 14.2833 13.0769 13.7958 13.4364 13.4364C13.7958 13.0769 14.2833 12.875 14.7917 12.875H28.2083ZM28.2083 14.7917H14.7917V28.2083H28.2083V14.7917ZM21.5355 17.407C21.7952 16.5751 22.9155 16.4965 23.3084 17.2306L23.3582 17.336L25.0238 21.5H26.2917C26.5359 21.5003 26.7709 21.5938 26.9485 21.7615C27.1261 21.9292 27.233 22.1583 27.2473 22.4022C27.2616 22.646 27.1823 22.8861 27.0255 23.0734C26.8687 23.2607 26.6463 23.3811 26.4038 23.41L26.2917 23.4167H24.3817C24.2082 23.4168 24.0378 23.3702 23.8884 23.2819C23.739 23.1935 23.6161 23.0666 23.5326 22.9145L23.4828 22.8091L22.5695 20.5244L20.9844 25.5969C20.7362 26.3904 19.6859 26.5102 19.2527 25.8413L19.1952 25.7406L18.0318 23.4167H16.7083C16.4641 23.4164 16.2291 23.3229 16.0515 23.1552C15.8739 22.9875 15.767 22.7583 15.7527 22.5145C15.7384 22.2707 15.8177 22.0306 15.9745 21.8432C16.1313 21.6559 16.3537 21.5356 16.5962 21.5067L16.7083 21.5H18.6193C18.9451 21.5 19.246 21.6629 19.4242 21.9303L19.4846 22.0357L19.8565 22.7794L21.5355 17.407V17.407Z",
    fill: "#2A9D8F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3766_23436"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerformanceWidgetIcon);
export default __webpack_public_path__ + "static/media/performance-widget-icon.737f2ea2c8d8483e373c5141c9c63ee0.svg";
export { ForwardRef as ReactComponent };